import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg viewBox="0 0 39 29" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M19.7 28.2L.5 9 8.8.7l10.9 10.8L30.5.7 38.9 9z" /></svg>);